import { render, staticRenderFns } from "./YoutubeVideoBottomRow.vue?vue&type=template&id=3d5dbd40&scoped=true&"
import script from "./YoutubeVideoBottomRow.vue?vue&type=script&lang=js&"
export * from "./YoutubeVideoBottomRow.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeVideoBottomRow.vue?vue&type=style&index=0&id=3d5dbd40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5dbd40",
  null
  
)

export default component.exports